export const NavbarBrand = () => null;
//# sourceMappingURL=NavbarBrand.js.map